import { useEffect } from 'react'

import { getPaymentCurrency } from '@enuygun/frontend-components'

import { useAppState } from 'context/AppContext'

type CurrencyFormatter = ReturnType<typeof getPaymentCurrency>

let CurrencyFormat: CurrencyFormatter | null = null

const normalizeLanguage = (language?: string | null): string => {
  if (!language) return 'en'
  return language.includes('-') ? language.split('-')[1] || language : language
}

/**
 * Dil bazlı para formatı (ayraç + konum profili).
 * `getPaymentCurrency` singleton ayraç/localeProfile günceller; `change` iso/conversion yazar.
 */
const useCurrency = () => {
  const { currency, language: rawLanguage } = useAppState()
  const language = normalizeLanguage(rawLanguage)

  CurrencyFormat = getPaymentCurrency({ language })

  if (currency) {
    CurrencyFormat.change(currency.iso, currency.conversion)
  }

  useEffect(() => {
    if (!currency) return
    const formatter = getPaymentCurrency({ language })
    formatter.change(currency.iso, currency.conversion)
    CurrencyFormat = formatter
  }, [currency, language])

  return CurrencyFormat || {}
}

export { useCurrency }
